/**
 * @generated SignedSource<<96ef7cb729aaca46fafd0587a871e4d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature$data = {
  readonly hasExpiredBatches: boolean;
  readonly hasPendingActions: boolean;
  readonly id: string;
  readonly " $fragmentType": "TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature";
};
export type TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature$key = {
  readonly " $data"?: TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExpiredBatches",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPendingActions",
      "storageKey": null
    }
  ],
  "type": "ProductDateTrackerTeamFeature",
  "abstractKey": null
};

(node as any).hash = "faf8f02a8e504e5a96f2d12a288fffe7";

export default node;
